import { g as getDB, l as link, m as magicLink } from "../../../../chunks/index3.js";
import { lte } from "drizzle-orm";
const cleanupLinks = async () => {
  const db = getDB();
  await db.delete(link).where(lte(link.expiresAt, /* @__PURE__ */ new Date())).run();
  await db.delete(magicLink).where(lte(magicLink.expiresAt, /* @__PURE__ */ new Date())).run();
};
const GET = () => {
  cleanupLinks();
  return new Response("", { status: 204 });
};
export {
  GET
};
